import React from 'react';
import { Button, Input, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export const SPARE_STOCK = 'Spare Stock';

export const buildBlobPdfUrl = (rawUrl) => {
  if (!rawUrl) return '';
  const filename = String(rawUrl).split(/[?#]/)[0].split('/').pop();
  if (!filename) return '';
  return `${process.env.REACT_APP_STORAGE_URL}${filename}`;
};

export const getStatusFromRecord = (record) => {
  if (!record) return 'to_be_cleaned';
  if (record.is_retired || record.is_active === false) return 'inactive';
  if (record.status === 'to_be_cleaned') return 'to_be_cleaned';
  if (record.status === 'in_use') {
    const area = String(record.current_area || '').toLowerCase();
    return area === 'spare stock' ? 'in_spare_stock' : 'in_use';
  }
  return 'to_be_cleaned';
};

export const STATUS_CONFIG = {
  in_use: { label: 'In Use', color: 'blue' },
  in_spare_stock: { label: 'In Spare Stock', color: 'green' },
  to_be_cleaned: { label: 'To Be Cleaned', color: 'orange' },
  inactive: { label: 'Inactive', color: 'default' }
};

export const ACTION_LABELS = {
  label_created: 'Label Created',
  assigned_to_area: 'Assigned to Area',
  sent_for_cleaning: 'Sent for Cleaning',
  marked_cleaned_and_assigned: 'Cleaned and Assigned',
  hvac_inactivated: 'Inactivated',
  hvac_reactivated: 'Reactivated'
};

export const formatDetails = (action, details) => {
  if (!details || typeof details !== 'object') return '';
  try {
    switch (action) {
      case 'label_created':
        return `Label generated at ${details.location || '—'}`;
      case 'assigned_to_area':
        return `From: ${details.from_area || '—'} → To: ${
          details.to_area || '—'
        }`;
      case 'sent_for_cleaning':
        return `Removed from: ${details.from_area || '—'}`;
      case 'marked_cleaned_and_assigned':
        return `Cleaned and assigned to: ${details.to_area || '—'}`;
      case 'hvac_inactivated':
        return `Reason: ${details.reason || '—'}`;
      case 'hvac_reactivated':
        return `Note: ${details.note || '—'} · Now at Spare Stock`;
      default:
        return JSON.stringify(details);
    }
  } catch (_) {
    return '';
  }
};

export const getColumnSearchProps = (dataIndex, getValue) => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters
  }) => (
    <div style={{ padding: 8 }}>
      <Input
        placeholder="Search"
        value={selectedKeys[0]}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={() => confirm()}
        style={{ marginBottom: 8, display: 'block', width: 200 }}
      />
      <Space>
        <Button
          type="primary"
          onClick={() => confirm()}
          size="small"
          style={{ width: 90 }}
        >
          Search
        </Button>
        <Button
          onClick={() => {
            clearFilters();
            confirm();
          }}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </Space>
    </div>
  ),
  filterIcon: (filtered) => (
    <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
  ),
  onFilter: (value, record) => {
    const cell = getValue ? getValue(record) : record[dataIndex];
    if (cell == null) return false;
    return cell.toString().toLowerCase().includes(value.toLowerCase());
  }
});
